import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { setNewUserInfo } from '../../api/editUserInfo';

import Button from '../ui/Button';
import './EditUserProfile.scss';

const EditUserProfile = ({
	username,
	email,
	headquarters,
	userId
}) => {
	const navigate = useNavigate();
	const { register, handleSubmit, reset } = useForm();

	const handleEditUserformSubmit = (data) => {
		const userData = {
			id: userId,
			changes: {
				lastname: data.lastname,
				firstname: data.fullname,
				department: data.headquarters,
				email: data.email.toLowerCase(),
				phone: data.phone
			}
		};
		setNewUserInfo(userData).then(() => {
			navigate('/dashboard');
		});
	};

	return (
		<div>
			<form
				className='edit-user-profile-form-container'
				onSubmit={handleSubmit(handleEditUserformSubmit)}
			>
				<div className='control-container row'>
					<div className='col-sm-6'>
						<label htmlFor='fullname'>First name</label>
						<input
							className='form-control'
							type='text'
							id='fullname'
							defaultValue={username.firstname}
							{...register('fullname')}
						/>
						<br />
						<label htmlFor='phone'>Phone number</label>
						<input
							className='form-control'
							type='text'
							id='phone'
							{...register('phone')}
						/>
					</div>
					<div className='col-sm-6'>
						<label htmlFor='lastname'>Last name</label>
						<input
							className='form-control'
							type='text'
							id='lastname'
							defaultValue={username.lastname}
							{...register('lastname')}
						/>
						<br />
						<label htmlFor='email'>Email address</label>
						<input
							className='form-control'
							type='email'
							id='email'
							defaultValue={email}
							{...register('email')}
						/>
					</div>
					<div className='col-sm-6'>
						<br />
						<label htmlFor='headquarters'>
							Headquarters
						</label>
						<input
							className='form-control'
							type='text'
							id='headquarters'
							defaultValue={headquarters}
							{...register('headquarters')}
						/>
					</div>
				</div>
				<div className='edit-user-profile-form-controler'>
					<Button className='primary-button' type='submit'>
						Save changes
					</Button>
				</div>
			</form>
		</div>
	);
};

export default EditUserProfile;
